import { render, staticRenderFns } from "./dislikes.vue?vue&type=template&id=0e39e4b4&scoped=true&"
import script from "./dislikes.vue?vue&type=script&lang=js&"
export * from "./dislikes.vue?vue&type=script&lang=js&"
import style0 from "./dislikes.vue?vue&type=style&index=0&id=0e39e4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e39e4b4",
  null
  
)

export default component.exports